import invoiceService from '../../api/services/invoiceService';
import { INVOICE_TEMPLATES } from './templates';

// Modèle de facture GLOBAL de l'entreprise : défini une fois, appliqué à toutes
// les factures. Source de vérité = backend (org-level) ; localStorage sert de
// cache pour un aperçu instantané et de repli hors-ligne.

export const BRANDING_KEY = 'swiftai_invoice_branding';

export const DEFAULT_BRANDING = {
  templateId: 'classic',
  brandColor: INVOICE_TEMPLATES[0].defaultAccent,
  logoUrl: '',
  companyName: '',
  companyAddress: '',
  companyPhone: '',
  companyEmail: '',
};

// Forme UI (plate) -> forme API ({ company: {...} })
export const toApi = (b = {}) => ({
  templateId: b.templateId || DEFAULT_BRANDING.templateId,
  brandColor: b.brandColor || DEFAULT_BRANDING.brandColor,
  logoUrl: b.logoUrl || '',
  company: {
    name: b.companyName || '',
    address: b.companyAddress || '',
    phone: b.companyPhone || '',
    email: b.companyEmail || '',
  },
});

// Forme API (ou facture) -> forme UI (plate)
export const fromApi = (s = {}) => ({
  templateId: s.templateId || DEFAULT_BRANDING.templateId,
  brandColor: s.brandColor || DEFAULT_BRANDING.brandColor,
  logoUrl: s.logoUrl || '',
  companyName: s.company?.name || s.companyName || '',
  companyAddress: s.company?.address || s.companyAddress || '',
  companyPhone: s.company?.phone || s.companyPhone || '',
  companyEmail: s.company?.email || s.companyEmail || '',
});

export const loadLocalBranding = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(BRANDING_KEY));
    return raw ? { ...DEFAULT_BRANDING, ...raw } : { ...DEFAULT_BRANDING };
  } catch {
    return { ...DEFAULT_BRANDING };
  }
};

export const saveLocalBranding = (b) => {
  try { localStorage.setItem(BRANDING_KEY, JSON.stringify(b)); } catch { /* quota/privé */ }
};

// Récupère le modèle global : backend en priorité, repli sur le cache local.
export const fetchBranding = async () => {
  try {
    const res = await invoiceService.getSettings();
    const data = res?.data || res;
    if (data && (data.templateId || data.company || data.logoUrl)) {
      const ui = fromApi(data);
      saveLocalBranding(ui); // garde le cache à jour
      return ui;
    }
  } catch {
    // endpoint indisponible (backend pas encore à jour) → on retombe sur le cache
  }
  return loadLocalBranding();
};

// Enregistre le modèle global : backend + cache local.
export const persistBranding = async (b) => {
  saveLocalBranding(b);
  await invoiceService.saveSettings(toApi(b));
};
